/**
 * API hatasını **her zaman string'e** çevirir.
 *
 * NEDEN GEREKLİ: FastAPI doğrulama hatalarında (422) `detail` bir STRING değil,
 * Pydantic hata **objelerinden oluşan dizidir**:
 *
 *   { detail: [ { type, loc, msg, input, ctx, url }, ... ] }
 *
 * Bu diziyi doğrudan JSX'e basmak React'i çökertir:
 *   "Minified React error #31 — Objects are not valid as a React child"
 * ve hata sınırı tüm uygulamayı beyaz ekrana düşürür. Yani **hatayı gösterme
 * girişimi, hatanın kendisinden daha büyük bir arızaya** dönüşür.
 *
 * Bu yüzden bir hata mesajı ekrana/toast'a basılacaksa MUTLAKA buradan geçmeli:
 *
 *   import { apiErrorMessage } from '../../utils/apiError'
 *   toast.error('Kaydedilemedi', apiErrorMessage(e))
 *   {isError && <div>{apiErrorMessage(error)}</div>}
 */

/** Tek bir Pydantic hata objesini okunur satıra çevirir. */
function pydanticLine(d) {
  if (!d || typeof d !== 'object') return String(d ?? '')
  const msg = d.msg || d.message || d.type || 'geçersiz değer'
  // loc: ['query','page_size'] → "page_size" (body/query/path etiketini at)
  const loc = Array.isArray(d.loc)
    ? d.loc.filter((p) => !['body', 'query', 'path', 'header'].includes(p)).join('.')
    : ''
  return loc ? `${loc}: ${msg}` : String(msg)
}

/**
 * @param {any} error axios hatası / Error / string
 * @returns {string} kullanıcıya gösterilebilir tek satırlık(lık) mesaj
 */
export function apiErrorMessage(error) {
  if (!error) return 'Bilinmeyen hata'
  if (typeof error === 'string') return error

  const detail = error?.response?.data?.detail

  // 422 — Pydantic hata dizisi
  if (Array.isArray(detail)) {
    const lines = detail.map(pydanticLine).filter(Boolean)
    return lines.length ? lines.join(' · ') : 'Geçersiz istek (doğrulama hatası)'
  }
  // detail düz string (projedeki HTTPException'ların normali)
  if (typeof detail === 'string' && detail.trim()) return detail
  // detail obje (nadiren)
  if (detail && typeof detail === 'object') {
    const line = pydanticLine(detail)
    if (line) return line
    try { return JSON.stringify(detail).slice(0, 300) } catch { /* noop */ }
  }

  // data doğrudan string olabilir (nginx/proxy hata sayfası vb.)
  const data = error?.response?.data
  if (typeof data === 'string' && data.trim() && data.length < 300) return data

  const status = error?.response?.status
  if (status) return `${status} ${error?.response?.statusText || ''}`.trim()

  return error?.message ? String(error.message) : 'Bilinmeyen hata'
}

export default apiErrorMessage
